var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { connect } from 'react-redux';
import * as UserFactory from '../../classes/definitions/user/user';
import ApiRequests from '../../classes/http/ApiRequests';
import HttpRequests from '../../classes/http/HttpRequests';
import UsersList from '../../components/Users/UsersList/UsersList';
import AppRoutes from '../../config/appRoutes';
import UsersReduxProps from './UsersReduxProps';
var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    function Users() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { pageNumber: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null,
            delaySearchTimer: null,
        };
        _this.getAllUsers = function (params) {
            _this.api
                .getUsers(params)
                .then(function (response) {
                var users = UserFactory.createUsers(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: users, meta: meta });
            })
                .catch(function (error) {
                var errorResponse = error.response;
                if (errorResponse.status === 401) {
                    if (errorResponse && errorResponse.config && errorResponse.config.headers) {
                        var headers = errorResponse.config.headers;
                        if (headers['X-Auth-Token']) {
                            _this.props.history.push(AppRoutes.notAuth.path);
                        }
                        else {
                            _this.http.handleError(error, _this.messages, 'Грешка! Моля, опитайте отново.', _this.props.history);
                        }
                    }
                    else {
                        _this.http.handleError(error, _this.messages, 'Грешка! Моля, опитайте отново.', _this.props.history);
                    }
                }
                else {
                    _this.http.handleError(error, _this.messages, 'Грешка! Моля, опитайте отново.', _this.props.history);
                }
            });
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        _this.search = function (event) {
            _this.queryParams.filter = event.target.value;
            clearTimeout(_this.state.delaySearchTimer);
            _this.setState({
                delaySearchTimer: setTimeout(function () {
                    _this.getAllUsers(_this.queryParams);
                }, 1000),
            });
        };
        _this.changePage = function (pageNum) {
            _this.queryParams.pageNumber = pageNum;
            _this.getAllUsers(_this.queryParams);
        };
        return _this;
    }
    Users.prototype.componentDidMount = function () {
        this.getAllUsers(this.queryParams);
    };
    Users.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta, errorMessage = _a.errorMessage;
        return (React.createElement("div", null, errorMessage ? (React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row justify-content-center" },
                React.createElement("form", { className: "col-md-5 login-form" },
                    React.createElement("div", { className: "card-group" },
                        React.createElement("div", { className: "card p-4" },
                            React.createElement("div", { className: "card-body" },
                                React.createElement(Messages, { ref: function (el) {
                                        _this.messages = el;
                                    } }),
                                React.createElement("h1", null, "\u0412\u0445\u043E\u0434"),
                                React.createElement("p", { className: "text-muted" }, "\u0412\u043B\u0435\u0437\u0442\u0435 \u0432 \u0430\u043A\u0430\u0443\u043D\u0442\u0430 \u0441\u0438."),
                                React.createElement("div", { className: "row" },
                                    React.createElement("div", { className: "col-6" },
                                        React.createElement("button", { className: "btn btn-primary px-4", type: "submit", id: "loginUser" }, "\u0412\u043F\u0438\u0441\u0432\u0430\u043D\u0435")))))))))) : (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Messages, { ref: function (el) {
                                _this.messages = el;
                            } }),
                        React.createElement(UsersList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem, meta: meta, changePage: this.changePage, search: this.search }))))))));
    };
    return Users;
}(React.Component));
export default connect(null, UsersReduxProps.mapDispatchToProps)(Users);



//////////////////
// WEBPACK FOOTER
// ./src/views/Users/Users.tsx
// module id = 493
// module chunks = 0